import { createSlice } from "@reduxjs/toolkit";

const adSlice = createSlice({
  name: "ad",
  initialState: {
    visibleAds: {},
  },
  reducers: {
    addAd: (prevState, action) => {
      const state = prevState;
      state.visibleAds[action.payload.id] = 0;
    },
    deleteAd: (prevState, action) => {
      const state = prevState;
      const { id } = action.payload;
      if ((!id) in state.visibleAds) {
        return;
      }
      const { [id]: _, ...remainingAds } = state.visibleAds;
      state.visibleAds = remainingAds;
    },
    incrementVisibleAd: (prevState, action) => {
      const state = prevState;
      const { id } = action.payload;
      if (id in state.visibleAds) {
        state.visibleAds[id]++;
      }
    },
  },
  selectors: {
    visibleAdsSelector: (state) => state.visibleAds,
  },
});

export const { visibleAdsSelector } = adSlice.selectors;
export const { addAd, deleteAd, incrementVisibleAd, decrementVisibleAd } = adSlice.actions;

export default adSlice.reducer;
